export enum CustomerConfirmationStatus {
  CONFIRMED = 'confirmed',
  CONFIRMATION_PENDING = 'confirmationPending',
}
